import formValidator, {
	isCorrectEmailLen,
	required,
	isEmail,
} from "@insightfulscience/shared-utils/validation";

export const initialState = {
	email: "",
};

const schema = {
	email: [
		[required, "errors.EMAIL_REQUIRED"],
		[isCorrectEmailLen(64), "errors.EMAIL_INVALID_LENGTH"],
		[isEmail, "errors.WRONG_EMAIL"],
	],
};

export const validateForm = formValidator(schema);
